import { createBrowserHistory } from 'history';
import { BASE_URL } from 'src/app/AppConstants';

export default createBrowserHistory({basename: BASE_URL, forceRefresh: false});

export const historyWithForceUpdate =  createBrowserHistory({basename: BASE_URL, forceRefresh: true});